//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins'
export default {
  // name: 'xxxxxxxx',
  mixins: [mixin],
  components: {
    //	xxxxxxxx
  },
  data() {
    return {
      type: 1,
    }
  },
  created() {
    // console.log('name', this.$route)

    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
  },
  mounted() {},
  methods: {},
  computed: {},
}



// WEBPACK FOOTER //
// ./src/pages/about.vue